module.exports = __webpack_public_path__ + "img/card-icon.37414074.svg";